import styled from 'styled-components';
import IconButton from '@material-ui/core/IconButton';

const AppBarIconButton = styled(IconButton)`
  && {
    padding: 10px;
  }
`;

AppBarIconButton.propTypes = { ...IconButton.propTypes };

export default AppBarIconButton;
